// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import BillingAndReview from './BillingAndReview';
import { IRoute } from '../';

const billingAndReviewRoutes: IRoute[] = [
    {
        crumbText: 'billing_and_review',
        component: BillingAndReview,
        exact: true,
        path: '/billingAndReview',
    },
];

export default billingAndReviewRoutes;
